import '../css/styles.css'
const Parse = require('parse');
const slackdown = require('slackdown');

// This sets up the parse server 
const STORAGE_ROOT = 'fnsz_app_last_';
const SERVER_URL = 'https://funsizeapps.b4a.app/';
const PEVENTS_ENDPOINT = 'getPersonalEvents';
const CEVENTS_ENDPOINT = 'getCompanyEvents';
const APP_ID = 'rHwkgreMFdjMqUGu9EoemDE4YMomVNLQwIX9Czr9';
const JAVASCRIPT_KEY = 'xdllsMsa2dAhWFuovVzyJTj7OIZmzLMeo5vsEFYv';
const REST_API_KEY = 'fabjEVYWZCwtBWXZ62BF3oAjU7ZzipumKecJidKJ';
Parse.initialize(APP_ID, JAVASCRIPT_KEY);
Parse.serverURL = SERVER_URL;

var funsizer, srch, srchContainer, resourceContainer, peepInfo, modal;
var funsizerLoaded = false;
var docsLoaded = false;
var remindersLoaded = false;

window.addEventListener('load', () => {
  gsap.to(document.getElementsByClassName('loader-container')[0], {opacity: 1, duration: 0.25});
  gsap.to(document.getElementsByClassName('loader')[0], {scale: 0.5, duration: 1, ease: "bounce.out", repeat: -1, yoyo: true});

  resourceContainer = document.getElementById('resources_data');
    srchContainer = document.getElementById('resources_search');
    srch = document.getElementById('search_field');
    srch.addEventListener('keyup', ()=>{
      doSearch();
    });
    document.getElementById('btn_search_cancel').addEventListener('click', ()=>{
      document.getElementById('resources_header').style.display = 'flex';
      srchContainer.style.display = 'none';
      srch.value = '';
      doSearch();
    });
    document.getElementById('btn_logout').addEventListener('click', ()=>{
      Parse.User.logOut().then(() => {
        initFunsizer(); 
      });
    });
    document.getElementById('btn_search').addEventListener('click', ()=>{
      document.getElementById('resources_header').style.display = 'none';
      srchContainer.style.display = 'flex';
      srch.focus();
    });
    document.getElementById('file-input').addEventListener('change', (event) => {
      console.log('change')
      const file = event.target.files[0];
      const src = URL.createObjectURL(file);
      document.getElementById('myspace-current-image').style.backgroundImage = `url(${src})`;
    });
    initFunsizer(); 
    const hiddens = document.querySelector('nav').getElementsByClassName('hidden');
    for(var i = 0; i < hiddens.length; i++){
      gsap.to(hiddens[i], {opacity: 1, duration: 0.35, delay: 0.2*i});
    }
    modal = document.querySelector('.modal-wrapper');
    document.getElementById('modal-close-btn').addEventListener('click', () => { modal.style.display = 'none'; })
    document.getElementById('myspace-user-save').addEventListener('click', () => { savePeepEdit(); })
});

const initFunsizer=()=>{
    funsizer = Parse.User.current();
    if (funsizer) {
        getFunsizerInfo().then((info) => {
          peepInfo = info;
          const outerContainer = document.getElementById('funsizer');

          const perp = document.createElement('div');
          perp.classList.add('myspace-user-info');
          outerContainer.prepend(perp);
          perp.addEventListener('click', ()=>{ showEditModal(); })
          
          const userImage = document.createElement('img');
          userImage.classList.add('profile-photo');
          userImage.setAttribute('id', 'user_image');
          userImage.setAttribute('alt', 'Portrait image of the logged in Funsizer')
          userImage.src = info.imageURL
          perp.append(userImage);

          const userInfo = document.createElement('div');
          userInfo.classList.add('info');
          perp.append(userInfo);

          const userName = document.createElement('p');
          userName.innerHTML = info.name;
          userName.classList.add('name')
          userInfo.append(userName);

          const userRole = document.createElement('p');
          userRole.innerHTML = info.role;
          userInfo.append(userRole);

          const userSince = document.createElement('p');
          const d = new Date(info.since);
          userSince.innerHTML = `Since ${d.getUTCFullYear()}`;
          userSince.classList.add('year');
          userInfo.appendChild(userSince);
          funsizerLoaded = true;
          showUI();
        }).catch(function(e){
          handleParseError('Error when fetching User Info', e);
        });
        getImportantLinks().then((links) => {
            renderImportantLinks(links);
          }).catch(function(e){  
            handleParseError('Error when fetching Important Links', e);
          });
        getReminders().then((reminders) =>{
            renderReminders(reminders);
        }).catch(function(e){
          handleParseError('Error when fetching Reminders', e);
        });
        initTimeZones();
    } else {
      window.location = `${window.location.origin}/${(window.location.pathname.includes("staging") ? "staging/" : "")}login.html?redirect=${window.location.pathname}`;
    }
}

const showEditModal = () => {
  modal.style.display = 'flex';
  document.getElementById('myspace-current-image').style.backgroundImage = `url(${peepInfo.imageURL})`;
  document.getElementById('myspace-name').value = peepInfo.name;
  document.getElementById('myspace-role').value = peepInfo.role;
  document.getElementById('myspace-current-image').addEventListener('click', () => {
    document.getElementById('file-input').click();
  })
}

const savePeepEdit = () => {
  const fInput = document.getElementById('file-input');
  var parseFile;

  var maxAllowedSize = 3 * 1024 * 1024; // 3 MB in bytes
  if (fInput.files.length > 0 && fInput.files[0].size > maxAllowedSize) {
    alert("🎵 You're so vain. 🎵 Plz limit your profile image to 3MB.");
      return;
  }
  if (document.getElementById('myspace-name').value.length < 1) {
      alert("🤔 What's your name?");
      return;
  }
  if (document.getElementById('myspace-role').value.length < 1) {
      alert("🤔 What do you do at Funsize?");
      return;
  }

  if (fInput.files.length > 0) {
    const file = fInput.files[0];
    const name = fInput.files[0].name;
    parseFile = new Parse.File(name, file);
  }
  if (parseFile) {
      parseFile.save().then(() => {
          savePeepCore(parseFile);
      }, function (error) {
          window.alert('Error while saving peep image', error);
      });
  }
  else {
      savePeepCore();
  };
}

const savePeepCore = (i) => {
  const Player = Parse.Object.extend('Player');
  const p = new Player();
  p.set('objectId', peepInfo.id);
  p.set('Name', document.getElementById('myspace-name').value);
  p.set('Role', document.getElementById('myspace-role').value);
  if (i) {
      p.set('ProfileImage', i);
  }
  p.save().then((r) => {
    modal.style.display = 'none';
    peepInfo.name = r.get('Name');
    peepInfo.role = r.get('Role');
    peepInfo.imageURL = r.get('ProfileImage').url();
    localStorage.setObject(`${STORAGE_ROOT}funsizer_info`, peepInfo);
    const outerContainer = document.getElementById('funsizer').childNodes[0];
    outerContainer.childNodes[0].src = peepInfo.imageURL;
    outerContainer.childNodes[1].childNodes[0].innerHTML = peepInfo.name;
    outerContainer.childNodes[1].childNodes[1].innerHTML = peepInfo.role;
  }, (error) => {
      alert('Failed updating peep info: ' + error);
  });
}

const showUI = () => {
  if(funsizerLoaded && docsLoaded && remindersLoaded){
    gsap.to(document.getElementsByClassName('loader-container')[0], {opacity: 0, duration: 0.25});
    const hiddens = document.getElementsByClassName('hidden');
    for(var i = 0; i < hiddens.length; i++){
      gsap.to(hiddens[i], {opacity: 1, duration: 0.35, delay: 0.2*i});
    }
  }
};

const doSearch = ()=>{
  let search = srch.value.toLowerCase();
  for(var i = 0; i < resourceContainer.childNodes.length; i++){
    let item = resourceContainer.childNodes[i].childNodes[0].innerHTML.toLowerCase();
    if (item.indexOf(search) == -1) { resourceContainer.childNodes[i].style.display = 'none'; }
    else { resourceContainer.childNodes[i].style.display = 'block'; }
  }
};

 /**
  * Important Links Calls
  */
  async function getImportantLinks(){
    if(!shouldLoadImportantLinksFromAPI()) {
      // console.log('retreiving existing links from storage');
      return localStorage.getObject(`${STORAGE_ROOT}links_data`);
    }
    try {
      // console.log('retreiving fresh links from api');
      const links = await Parse.Cloud.run('importantLinks');
      const d = new Date();
      const day = d.getDay();
      localStorage.setObject(`${STORAGE_ROOT}links_load`, day);
      localStorage.setObject(`${STORAGE_ROOT}links_data`, links);
      return localStorage.getObject(`${STORAGE_ROOT}links_data`);
    } catch (error) {
        throw error;      
    }
 }

 const shouldLoadImportantLinksFromAPI=()=>{
  const d = new Date();
  const day = d.getDay();
  const lastDay = localStorage.getObject(`${STORAGE_ROOT}links_load`);
  const data = localStorage.getObject(`${STORAGE_ROOT}links_data`);
  if(lastDay == null || data == null) { 
    localStorage.setObject(`${STORAGE_ROOT}links_load`, day); 
    return true;
  }
  return day != lastDay; // only refresh if a new day
 }

 const renderImportantLinks=(links)=>{
  docsLoaded = true;
  showUI();

  if(links.length == 0) { 
    //TODO: render empty state 
    return;
  }

  resourceContainer.innerHTML = '';
  for(var i = 0; i < links.length; i++){
    //TODO: Make this whole thing an anchor and the container a div
    const l = document.createElement('li');
    resourceContainer.appendChild(l);
    const a = document.createElement('a');
    l.appendChild(a);
    a.innerHTML = links[i].Title;
    a.href = links[i].URL;
    a.target = "_blank";
    const img = document.createElement('img');
    a.appendChild(img);
    const url = new URL('../svgs/chevron-right.svg', import.meta.url);
    img.src = url;
  }
}

/**
 * Reminders Calls
 */
const reminderTimer = 5;  //every 5 minutes
var currentReminderTimer = 0;
async function  getReminders() {
  const FunsizeAppMention = Parse.Object.extend('FunsizeAppMention');
  const query = new Parse.Query(FunsizeAppMention); 
  query.descending("createdAt");
  try {
      const reminders = await query.find();
      return reminders;
  } catch (error) {
    throw(error);
  }
}

const renderReminders=(reminders)=>{
  remindersLoaded = true;
  showUI();

  const messageList = document.getElementById('message-list');
  messageList.innerHTML = '';
  for(var i = 0; i < reminders.length; i++) {
      const s = slackdown.parse(reminders[i].get('message')).replace('<span class="slack-user">03UWU5RDA9</span>', '');

      const li = document.createElement('li');
      const meta = document.createElement('div');
      const postAuthor = document.createElement('p');
      const postDate = document.createElement('p');
      const postTime = document.createElement('p');
      const message = document.createElement('p');

      meta.classList.add('metadata');
      message.classList.add('slack-message');

      const d = new Date(reminders[i].get('postDate'));
      const dh = d.getHours();
      var minutes = d.getMinutes();
      minutes =  minutes < 10 ? '0'+minutes : minutes;
      postAuthor.innerHTML = reminders[i].get('name');
      postDate.innerHTML = `${d.toLocaleString('en-US', { month: 'short' })} ${d.getDate()}`;
      postTime.innerHTML = `${dh > 12 ? dh - 12 : dh}:${minutes}${dh >= 12 ? 'PM' : 'AM'}`;
      message.innerHTML = s;

      messageList.append(li);
      li.append(meta, message);
      meta.append(postAuthor, postDate, postTime);
  }
}

/**
 * User info call
 */

 async function getFunsizerInfo(){
  const info = localStorage.getObject(`${STORAGE_ROOT}funsizer_info`);
  if(!info || !info.id) { 
    const query = new Parse.Query('Player');
    query.equalTo('Email', funsizer.get('email'));
    query.select('Name', 'Email', 'Role', 'StartDate', 'ProfileImage');
    try {
      // console.log(query)
        var p = await query.find();
        p = p[0];
        // console.log(p)
        const peep = new Object();
        peep.id = p.id;
        peep.name = p.get('Name');
        peep.role = p.get('Role');
        peep.since = p.get('StartDate');
        peep.imageURL = p.get('ProfileImage') ? p.get('ProfileImage').url() : './resources/unknown.png';
        localStorage.setObject(`${STORAGE_ROOT}funsizer_info`, peep);
        return localStorage.getObject(`${STORAGE_ROOT}funsizer_info`);
    } catch (error) {
        throw(error);    
    }
  }
  return info;
}

/**
 * Timezone calls
 */
const initTimeZones=()=>{
  const current = new Date();
  setTime();
  setInterval(()=>{
    setTime();
    currentReminderTimer++;
    if(currentReminderTimer >= reminderTimer){
      // console.log('setting reminders')
      currentReminderTimer = 0;
      getReminders().then((reminders) =>{
        renderReminders(reminders);
      }).catch(function(e){
        handleParseError('Error when fetching Reminders', e);
      });
    }
  }, 60 * 1000);
}

const setTime=()=>{
  const current = new Date();
  var minutes = current.getUTCMinutes();
  minutes = minutes < 10 ? '0'+minutes : minutes;
  const est = new Date(current.toLocaleString("en-US", {timeZone: 'America/Detroit'})).getHours();
  const cst = new Date(current.toLocaleString("en-US", {timeZone: 'America/Chicago'})).getHours();
  const isl = new Date(current.toLocaleString("en-US", {timeZone: 'Iceland'})).getHours();
  const pst = new Date(current.toLocaleString("en-US", {timeZone: 'America/Los_Angeles'})).getHours();

  document.getElementById('pst').innerHTML = `${pst > 12 ? pst - 12 : pst}:${minutes}${pst >= 12 ? 'PM' : 'AM'}`;
  document.getElementById('isl').innerHTML = `${isl > 12 ? isl - 12 : isl}:${minutes}${isl >= 12 ? 'PM' : 'AM'}`;
  document.getElementById('cst').innerHTML = `${cst > 12 ? cst - 12 : cst}:${minutes}${cst >= 12 ? 'PM' : 'AM'}`;
  document.getElementById('est').innerHTML = `${est > 12 ? est - 12 : est}:${minutes}${est >= 12 ? 'PM' : 'AM'}`;
}

function handleParseError(msg, err) {
  switch (err.code) {
    case Parse.Error.INVALID_SESSION_TOKEN:
      alert('Invalid session token.');
      Parse.User.logOut();
      window.location = `${window.location.origin}/${(window.location.pathname.includes("staging") ? "staging/" : "")}login.html?redirect=${window.location.pathname}`;
      break;
    default:
      console.log(`${msg} : ${err.code} - ${err.message}`);
  }
}

Storage.prototype.setObject = function(key, value) {
  this.setItem(key, JSON.stringify(value));
}

Storage.prototype.getObject = function(key) {
  var value = this.getItem(key);
  return value && JSON.parse(value);
}